import { pxToRem } from '../../../../lib';
export default (function (siteVars) {
  return {
    colorDisabled: siteVars.colors.grey[250],
    textFontSize: siteVars.fontSizes.medium,
    textColorDefault: siteVars.colors.grey[500],
    textColorDefaultHoverFocus: siteVars.colors.grey[750],
    textColorChecked: siteVars.colors.grey[750],
    iconBorderColorDefaultHover: siteVars.colors.grey[750],
    iconBorderColorChecked: siteVars.colors.brand[600],
    iconBackgroundColorChecked: siteVars.colors.brand[600],
    padding: "0 ".concat(pxToRem(4))
  };
});